module.exports = __webpack_public_path__ + "static/media/burgerBuilder.93594420.jpg";